<!-- eslint-disable prettier/prettier -->
<template>
  <div>
    <rabbey-toolbox :filterables="true" @filter-search="handleSearch">
      <div class="mr-5">
        <el-button
          size="mini"
          type="primary"
          icon="el-icon-refresh"
          :loading="loading"
          @click="fetchData"
        >Actualizar</el-button>
      </div>
    </rabbey-toolbox>

    <rabbey-table3
      :data="renderItems"
      :columns="columns"
      :loading="loading"
      :actions="actions"
      @rtable-push-action="handleCommand"
    />

    <!-- Drawer: Ver detalle de la orden -->
    <rabbey-base-drawer
      :drawer.sync="verDrawer.visible"
      :title="verDrawer.title"
      size="70%"
    >
      <div v-loading="verDrawer.loading">
        <template v-if="verDrawer.data">
          <!-- Header: datos generales de la orden -->
          <el-descriptions
            :column="4"
            border
            size="small"
            class="mb-3"
          >
            <el-descriptions-item label="Empresa">
              {{ verDrawer.data.EmpresaNombre }}
            </el-descriptions-item>
            <el-descriptions-item label="Cliente">
              {{ verDrawer.data.ClienteNombre }}
            </el-descriptions-item>
            <el-descriptions-item label="Cantidad">
              {{ verDrawer.data.Cantidad }}
            </el-descriptions-item>
            <el-descriptions-item label="Tipo Consumo">
              {{ verDrawer.data.TipoConsumo }}
            </el-descriptions-item>
          </el-descriptions>

          <!-- Tabla de tarjetahabientes -->
          <p class="section-title">Tarjetahabientes</p>
          <rabbey-table3
            :data="verDetalleItems"
            :columns="verDetalleColumns"
            :loading="false"
          />
        </template>
        <el-empty v-else-if="!verDrawer.loading" description="Sin datos" />
      </div>
    </rabbey-base-drawer>

    <!-- Drawer: Ver Tarjetas -->
    <rabbey-base-drawer
      :drawer.sync="tarjetasDrawer.visible"
      :title="tarjetasDrawer.title"
      size="60%"
    >
      <div v-loading="tarjetasDrawer.loading">
        <el-row class="mb-2">
          <el-col>
            <el-tag type="info" class="mr-2">Empresa: {{ tarjetasDrawer.empresa }}</el-tag>
            <el-tag type="info" class="mr-2">Cliente: {{ tarjetasDrawer.cliente }}</el-tag>
            <el-tag type="info">Cantidad: {{ tarjetasDrawer.cantidad }}</el-tag>
          </el-col>
        </el-row>
        <rabbey-table3
          v-if="tarjetasDrawer.items.length > 0"
          :data="tarjetasDrawer.items"
          border
          stripe
          size="small"
          style="width: 100%"
          :columns="tarjetasColumns"/>
        <el-empty v-else-if="!tarjetasDrawer.loading" description="Sin tarjetas registradas" />
      </div>
    </rabbey-base-drawer>

    <!-- Diálogo de confirmación: Eliminar -->
    <!-- Manejado directamente con this.$confirm en handleCommand -->
  </div>
</template>

<script>
const BASE_URL = "/api/serviceRequests/CardOrders";

export default {
  name: "OrdenTarjetas",

  created() {
    this.fetchData();
  },

  data() {
    return {
      loading: false,
      items: [],
      search: "",

      /** Columnas de la tabla principal */
      columns: [
        {
          prop: "OrdenId",
          label: "OrdenId",
          width: 100,
          sortable: true,
          fixed: true
        },
        {
          prop: "EmpresaNombre",
          label: "Empresa",
          minWidth: 150,
          sortable: true
        },
        {
          prop: "ClienteNombre",
          label: "Cliente",
          minWidth: 200,
          sortable: true
        },
        {
          prop: "Cantidad",
          label: "Cantidad",
          width: 100,
          sortable: true,
          align: "center"
        },
        {
          prop: "TipoConsumo",
          label: "Tipo Consumo",
          minWidth: 140,
          sortable: true
        },
        {
          prop: "EstatusNombre",
          label: "Estatus",
          minWidth: 130,
          sortable: true
        },
        {
          prop: "CreatedAt",
          label: "Fecha Creación",
          minWidth: 170,
          sortable: true,
          formatter: (row, column, cellValue) => this.formatDate(cellValue)
        },
        {
          prop: "FechaAprovacion",
          label: "Fecha Aceptación",
          minWidth: 170,
          sortable: true,
          formatter: (row, column, cellValue) => this.formatDate(cellValue)
        }
      ],

      /** Acciones disponibles por fila */
      actions: [
        {
          icon: "el-icon-view",
          label: "Ver",
          command: "view"
        },
        {
          icon: "el-icon-postcard",
          label: "Ver Tarjetas",
          command: "view-cards"
        },
        {
          icon: "el-icon-printer",
          label: "En impresión",
          command: "set-printing"
        },
        {
          icon: "el-icon-circle-check",
          label: "Completada",
          command: "set-completed"
        },
        {
          icon: "el-icon-delete",
          label: "Eliminar",
          command: "delete"
        }
      ],

      /** Estado del drawer "Ver" */
      verDrawer: {
        visible: false,
        loading: false,
        title: "Detalle de Orden",
        data: null
      },

      /** Columnas de la tabla de tarjetahabientes dentro del drawer Ver */
      verDetalleColumns: [
        {
          prop: "OrdenId",
          label: "OrdenId",
          width: 90,
          sortable: true
        },
        {
          prop: "Nombre",
          label: "Nombre",
          minWidth: 180,
          sortable: true
        },
        {
          prop: "Cedula",
          label: "Cédula",
          minWidth: 130,
          sortable: true
        },
        {
          prop: "Celular",
          label: "Celular",
          minWidth: 120,
          sortable: true
        },
        {
          prop: "Correo",
          label: "Correo",
          minWidth: 200,
          sortable: true
        },
        {
          prop: "Placa",
          label: "Placa",
          minWidth: 100,
          sortable: true
        },
        {
          prop: "KM",
          label: "KM",
          minWidth: 90,
          sortable: true,
          align: "center"
        }
      ],

      /** Estado del drawer "Ver Tarjetas" */
      tarjetasDrawer: {
        visible: false,
        loading: false,
        title: "Tarjetas de la Orden",
        items: [],
        empresa: "",
        cliente: "",
        cantidad: 0
      },

      /** Columnas de la tabla de tarjetas (se adapta a lo que devuelva la API) */
      tarjetasColumns: []
    };
  },

  computed: {
    /** Items filtrados según la búsqueda local */
    renderItems() {
      const q = (this.search || "").toLowerCase().trim();
      if (!q || this.items.length === 0) return this.items;

      return this.items.filter((row) => {
        return Object.values(row).some((val) => {
          if (val === null || val === undefined) return false;
          return String(val).toLowerCase().includes(q);
        });
      });
    },

    /**
     * Extrae el array de tarjetahabientes de la respuesta del endpoint
     * GET CardOrders/{ordenId}.
     *
     * La API puede devolver la colección bajo distintos nombres de campo;
     * se prueba en orden de probabilidad y se devuelve el primero que sea
     * un array no vacío. Si no se encuentra ninguno, retorna [].
     */
    verDetalleItems() {
      const data = this.verDrawer.data;
      if (!data) return [];

      // Candidatos comunes para el array de detalle
      const candidates = [
        "Detalle",
        "Tarjetahabientes",
        "Tarjetas",
        "Items",
        "Cards",
        "Details"
      ];

      for (const key of candidates) {
        if (Array.isArray(data[key])) return data[key];
      }

      // Fallback: buscar cualquier campo que sea un array
      const arrayField = Object.values(data).find((v) => Array.isArray(v));
      return arrayField || [];
    }
  },

  methods: {
    /** Cargar lista principal */
    fetchData() {
      this.loading = true;
      this.$http
        .get(BASE_URL)
        .then((res) => {
          this.items = res.data || [];
        })
        .catch(() => {
          this.$notify.error({
            title: "Error",
            message: "No se pudo cargar la lista de órdenes de tarjetas."
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },

    /** Búsqueda local desde rabbey-toolbox */
    handleSearch(value) {
      this.search = value;
    },

    /** Dispatcher de acciones de la tabla */
    handleCommand({ command, row }) {
      switch (command) {
        case "view":
          this.openVerDrawer(row);
          break;
        case "view-cards":
          this.openTarjetasDrawer(row);
          break;
        case "set-printing":
          this.changeStatus(row, 4, "En impresión");
          break;
        case "set-completed":
          this.changeStatus(row, 5, "Completada");
          break;
        case "delete":
          this.confirmDelete(row);
          break;
        default:
          break;
      }
    },

    /** Abrir drawer "Ver" y cargar detalle */
    openVerDrawer(row) {
      this.verDrawer.visible = true;
      this.verDrawer.loading = true;
      this.verDrawer.data = null;
      this.verDrawer.title = `Orden #${row.OrdenId} — ${row.EmpresaNombre} / ${row.ClienteNombre} (${row.Cantidad})`;

      this.$http
        .get(`${BASE_URL}/${row.OrdenId}`)
        .then((res) => {
          this.verDrawer.data = res.data;
        })
        .catch(() => {
          this.$notify.error({
            title: "Error",
            message: "No se pudo cargar el detalle de la orden."
          });
          this.verDrawer.visible = false;
        })
        .finally(() => {
          this.verDrawer.loading = false;
        });
    },

    /** Abrir drawer "Ver Tarjetas" y cargar tarjetas */
    openTarjetasDrawer(row) {
      this.tarjetasDrawer.visible = true;
      this.tarjetasDrawer.loading = true;
      this.tarjetasDrawer.items = [];
      this.tarjetasDrawer.empresa = row.EmpresaNombre;
      this.tarjetasDrawer.cliente = row.ClienteNombre;
      this.tarjetasDrawer.cantidad = row.Cantidad;
      this.tarjetasDrawer.title = `Tarjetas — ${row.EmpresaNombre} / ${row.ClienteNombre} (${row.Cantidad})`;

      this.$http
        .get(`${BASE_URL}/${row.OrdenId}/Cards`)
        .then((res) => {
          const data = res.data || [];
          this.tarjetasDrawer.items = data;
          // Generar columnas dinámicamente a partir del primer item
          if (data.length > 0) {
            this.tarjetasColumns = Object.keys(data[0]).map((key) => ({
              prop: key,
              label: key,
              minWidth: 140
            }));
          } else {
            this.tarjetasColumns = [];
          }
        })
        .catch(() => {
          this.$notify.error({
            title: "Error",
            message: "No se pudo cargar las tarjetas de la orden."
          });
          this.tarjetasDrawer.visible = false;
        })
        .finally(() => {
          this.tarjetasDrawer.loading = false;
        });
    },

    /** Cambiar estatus de la orden (En impresión = 4, Completada = 5) */
    changeStatus(row, estatus, label) {
      this.$http
        .put(`${BASE_URL}/${row.OrdenId}/Status`, { estatus })
        .then(() => {
          this.$notify.success({
            title: "Éxito",
            message: `Orden #${row.OrdenId} marcada como "${label}".`
          });
          this.fetchData();
        })
        .catch(() => {
          this.$notify.error({
            title: "Error",
            message: `No se pudo cambiar el estatus de la orden #${row.OrdenId}.`
          });
        });
    },

    /** Confirmar y ejecutar eliminación */
    confirmDelete(row) {
      this.$confirm(
        `¿Está seguro de que desea eliminar la orden #${row.OrdenId} de ${row.Cliente}? Esta acción no se puede deshacer.`,
        "Confirmar eliminación",
        {
          confirmButtonText: "Eliminar",
          cancelButtonText: "Cancelar",
          type: "warning",
          confirmButtonClass: "el-button--danger"
        }
      )
        .then(() => {
          this.$http
            .put(`${BASE_URL}/${row.OrdenId}/Delete`)
            .then(() => {
              this.$notify.success({
                title: "Éxito",
                message: `Orden #${row.OrdenId} eliminada correctamente.`
              });
              this.fetchData();
            })
            .catch(() => {
              this.$notify.error({
                title: "Error",
                message: `No se pudo eliminar la orden #${row.OrdenId}.`
              });
            });
        })
        .catch(() => {
          // El usuario canceló — no hacer nada
        });
    },

    /** Formato de fecha legible */
    formatDate(value) {
      if (!value) return "";
      const d = new Date(value);
      if (isNaN(d.getTime())) return value;
      return d.toLocaleDateString("es-DO", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit"
      });
    }
  }
};
</script>

<style scoped>
.mb-2 {
  margin-bottom: 8px;
}
.mb-3 {
  margin-bottom: 16px;
}
.mr-2 {
  margin-right: 8px;
}
.section-title {
  font-size: 13px;
  font-weight: 600;
  color: #606266;
  margin: 0 0 8px 0;
  padding-left: 2px;
  border-left: 3px solid #409eff;
  padding-left: 8px;
}
</style>
